import { createFileRoute } from '@tanstack/react-router';
import AuthGuard from '@/components/auth-guard';
import { CashFlowManager } from '@/components/financial/cash-flow-manager';

export const Route = createFileRoute('/cashflow')({
  component: CashFlowPage,
});

function CashFlowPage() {
  return (
    <AuthGuard requireAuth={true}>
      <div className="container mx-auto space-y-6 px-4 py-6">
        <div>
          <h1 className="font-bold text-2xl tracking-tight">
            Fluxo de Caixa Projetado
          </h1>
          <p className="text-muted-foreground">
            Veja o saldo projetado dia a dia e identifique períodos críticos
          </p>
        </div>

        <CashFlowManager />
      </div>
    </AuthGuard>
  );
}
